<template>
  <div>
    <Legenda :titulo="info.titulo" :legenda="info.detalhamento">
      <v-btn icon :class="content_class" @click.stop="dialog_ativo = ! dialog_ativo">
        <v-icon>mdi-eye-plus</v-icon>
      </v-btn>
    </Legenda>

    <SysDialogFullScreen v-model="dialog_ativo" :largura="1100" exibir-divisor-topo>
      <template #titulo.text>
        <div class="pt-2">
          <p class="ma-0 font-20 font-weight-medium">{{ info.titulo }}</p>
          <p class="ma-0 font-12 mt-n3 font-weight-regular">{{ `${produto.idproduto} - ${produto.descricao_produto}` }}</p>
        </div>
        <span class="ml-2">
          <ConverterEmbalagem class="mr-4" dark />
        </span>
      </template>

      <div class="d-flex align-start">
        <Tabelas
          v-model="menu_lateral_ativo"
          :idgrupo="parseInt(produto.id_grupo)"
          :filial="parseInt(produto.filial || 0)"
          :produtos="produto.produtos ? produto.produtos : [produto.idproduto]"
          :idproduto="produto.idproduto"
          :quantidade_compra="Number(produto.sugestao || 0)"
          :card_completar_compra="card_completar_compra"
          :class="{'w-40-porcento': menu_lateral_ativo}"
          @dadosConversao="ev => obterDadosConversao(ev)"
        />

        <div
          :class="{'w-60-porcento': menu_lateral_ativo, 'w-full': !menu_lateral_ativo}"
          class="px-2 mt-3"
          style="height: calc(100vh - 78px)"
        >
          <Grafico
            v-if="dialog_ativo"
            :resize="menu_lateral_ativo"
            :idgrupo="parseInt(produto.id_grupo)"
            :filial="parseInt(produto.filial || 0)"
            :produtos="produto.produtos ? produto.produtos : [produto.idproduto]"
            :idproduto="produto.idproduto"
            :quantidade_compra="Number(produto.sugestao || 0)"
            :card_completar_compra="card_completar_compra"
            :dados_conversao="{
              tipo_fator_conversao: this.detalhamento.tipo_fator_conversao,
              multiplo_compra: this.detalhamento.multiplo_compra
            }"
          />
        </div>
      </div>
    </SysDialogFullScreen>
  </div>
</template>

<script>
import SysDialogFullScreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import Grafico from "@/components/produto/Compras/DetalhamentoSugestao/Grafico";
import Legenda from "@/components/produto/detalhes/Legenda";
import Tabelas from "@/components/produto/Compras/DetalhamentoSugestao/Tabelas/Index.vue";
import ConverterEmbalagem from "@/components/compra/Embalagem/ConverterEmbalagem";

export default {
  name: "DetalhamentoSugestaoCompra",
  components: {
    Tabelas,
    Legenda,
    SysDialogFullScreen,
    Grafico,
    ConverterEmbalagem
  },
  props: {
    content_class: String,
    produto: Object,
    card_completar_compra: Boolean,
  },
  data: () => ({
    dialog_ativo: false,
    menu_lateral_ativo: false,
    info: {
      titulo: 'Detalhamento da Sugestão de Compra',
      detalhamento: 'Este indicador projeta o tempo de ressuprimento do produto, exibindo diariamente o Saldo de Estoque, as Saídas e Entradas. Demonstrando como o Saldo de Estoque estará quando a quantidade sugerida for entregue.'
    },
    detalhamento: {}
  }),
  methods: {
    obterDadosConversao(evento) {
      this.detalhamento = evento
    }
  },
}
</script>

<style scoped>

</style>
